import { render, staticRenderFns } from "./VotingEnded.vue?vue&type=template&id=3b95db4d&scoped=true&"
import script from "./VotingEnded.vue?vue&type=script&lang=js&"
export * from "./VotingEnded.vue?vue&type=script&lang=js&"
import style0 from "./VotingEnded.vue?vue&type=style&index=0&id=3b95db4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95db4d",
  null
  
)

export default component.exports